import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import VideoPlayer from '../../modal/VideoPlayer.modal';
var Tour = function Tour(_ref) {
  var showModalAction = _ref.showModalAction;
  return /*#__PURE__*/React.createElement("div", {
    className: "landingpage__tour",
    onMouseEnter: function onMouseEnter() {
      $('.landingpage__tour--ro').css({
        opacity: 1
      });
    },
    onMouseLeave: function onMouseLeave() {
      $('.landingpage__tour--ro').css({
        opacity: 0
      });
    },
    onClick: function onClick() {
      showModalAction({
        component: /*#__PURE__*/React.createElement(VideoPlayer, {
          url: "/public/images/take-a-tour.mp4"
        })
      });
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/landingpage/Posillico-Wash-Plant-Tour.png"
  }), /*#__PURE__*/React.createElement("div", {
    className: "landingpage__tour--ro"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/landingpage/Posillico-Wash-Plant-Tour-RO.png"
  })));
};
var mdtp = {
  showModalAction: modalActions.show
};
export default connect(null, mdtp)(Tour);